import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

export type OrganizationOwner = Schema["OrganizationOwnerMember"];

export function listOrganizationOwners(orgId: string): Promise<OrganizationOwner[]> {
  return httpClient.get(`/orgs/${encodeURIComponent(orgId)}/owners`);
}

export function promoteOrganizationOwner(orgId: string, memberId: string): Promise<OrganizationOwner[]> {
  return httpClient.post(`/orgs/${encodeURIComponent(orgId)}/owners`, { team_member_id: memberId });
}

export function removeOrganizationOwner(orgId: string, userId: string): Promise<void> {
  return httpClient.post(`/orgs/${encodeURIComponent(orgId)}/owners/remove`, { user_id: userId });
}

export function setPrimaryBillingAdmin(orgId: string, userId: string): Promise<void> {
  return httpClient.put(`/orgs/${encodeURIComponent(orgId)}/primary-billing-admin`, { user_id: userId });
}
